import type { EspaceCompany } from "@shared/espace.types";
import { useEffect, useState } from "react";
import { fetchJson } from "./http";

/**
 * Qui dépose, quand la page publique est ouverte depuis l'espace.
 *
 * La page de dépôt est publique et le reste : elle marche pour un inconnu. Mais une
 * entreprise qui a déjà un espace y arrive avec une session, et lui redemander son
 * email, son nom et son entreprise serait lui faire ressaisir ce que l'écran d'à côté
 * affiche.
 *
 * Le 401 est le cas NORMAL, pas une erreur : la plupart des visiteurs sont inconnus.
 */
export type KnownContact = {
	fullName: string | null;
	email: string;
	phone: string | null;
	company: EspaceCompany | null;
};

type EspaceReponse = {
	contact: { fullName: string | null; email: string; phone: string | null };
	company: EspaceCompany | null;
};

export function useKnownContact(): { loaded: boolean; contact: KnownContact | null } {
	const [state, setState] = useState<{ loaded: boolean; contact: KnownContact | null }>({
		loaded: false,
		contact: null,
	});

	useEffect(() => {
		let cancelled = false;
		fetchJson<EspaceReponse>("/api/espace")
			.then((body) => {
				if (cancelled) return;
				setState({ loaded: true, contact: { ...body.contact, company: body.company } });
			})
			.catch(() => {
				// Le 401 du visiteur inconnu arrive ici : ce `catch` est le chemin normal,
				// pas un rattrapage. Une panne y tombe aussi, et c'est voulu : le
				// formulaire marche sans session, au prix d'une saisie à refaire. Bloquer
				// le dépôt le temps de savoir qui vient coûterait plus cher que ça.
				if (!cancelled) setState({ loaded: true, contact: null });
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return state;
}
